export default __webpack_public_path__ + "static/media/eyeGreen.c7373dd3.svg";